import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'tiNoValue',
})
export class NoValuePipe implements PipeTransform {
  transform(value: any, emptyValue: string): string {
    return value ? value : `(${emptyValue ? emptyValue : tiStrings.app.misc.notSet})`;
  }
}
